module.exports = __webpack_public_path__ + "img/histogramme.0b2507cb.svg";